import { format, formatInTimeZone } from 'date-fns-tz'
import * as React from 'react'

export interface Props {
  readonly tzname: 'Australia/Sydney' | 'Asia/Tokyo'
  readonly time: Date
}

function HeaderClock({ tzname, time }: Props): JSX.Element {
  return (
    <div className='clock'>
      <div className='clock__digits'>
        {formatInTimeZone(time, tzname, 'HH:mm:ss')}
      </div>
      <div className='clock__zone'>{tzname}</div>
    </div>
  )
}

export default HeaderClock
